import React from 'react';

import { Outlet } from 'react-router-dom';
const SharedProductLayout = () => {
  return (
    <>
       
      <Outlet />
    </>
  );
};
export default SharedProductLayout;
